import { COMTRUEVAR } from '../default/ocr_variables'
import { sendPostMessageClose, closeThis } from '../default/common'

// utils/COMTRUEEncryptUtils.js
export const createCOMTRUEEncryptUtils = () => {
    const importRsaKeys = () => {
        console.log('importRsaKeys start ..')

        return new Promise((resolve, reject) => {
            // [2025.06.16] encryptView 조건 변경, 자바스크립트에서 string 으로 들어오는 경우가 있음
            if (
                COMTRUEVAR.encryptView === true ||
                COMTRUEVAR.encryptView === 'true'
            ) {
                // [25.06.16] 비동기 함수 호출 오류 수정. 두 함수의 promise가 모두 반환된 후에 resolve를 실행하도록 수정
                const pubKey = localStorage.getItem('pubKey')
                const priKey = localStorage.getItem('priKey')

                Promise.all([importPublicKey(pubKey), importPrivateKey(priKey)])
                    .then(([publicKey, privateKey]) => {
                        COMTRUEVAR.requestEncryptPublicKeyComtrue = publicKey
                        COMTRUEVAR.responseDecryptPrivateKeyComtrue = privateKey
                        resolve('success')
                    })
                    .catch((error) => {
                        console.log('RSA 키 import 실패: ', error)
                        reject('fail')
                    })
            } else {
                resolve('success')
            }
        })
    }

    const arrayToArrayBuffer = (arr) => {
        const buf = new ArrayBuffer(arr.length)
        const bufView = new Uint8Array(buf)
        for (let i = 0; i < arr.length; i++) {
            bufView[i] = arr[i]
        }
        return buf
    }

    const stringToArrayBuffer = (str) => {
        console.log('stringToArrayBuffer start !!! ')
        const buf = new ArrayBuffer(str.length)
        const bufView = new Uint8Array(buf)
        for (let i = 0; i < str.length; i++) {
            bufView[i] = str.charCodeAt(i)
        }
        return buf
    }

    const arrayBufferToString = (arrayBuffer) => {
        const byteArray = new Uint8Array(arrayBuffer)
        let byteString = ''
        for (let i = 0; i < byteArray.byteLength; i++) {
            byteString += String.fromCodePoint(byteArray[i])
        }
        return byteString
    }

    const stringToArray = (str) => {
        const bufView = new Uint8Array(new ArrayBuffer(str.length))
        for (let i = 0; i < str.length; i++) {
            bufView[i] = str.charCodeAt(i)
        }
        return bufView
    }

    const encryptDataWithPublicKey = (uint8Array, cardType) => {
        console.log(
            'function COMTRUEEncryptUtils.encryptDataWithPublicKey start!'
        )
        const divideIndex = 100
        const prefixBytes = uint8Array.subarray(0, divideIndex)
        const suffixBytes = uint8Array.subarray(divideIndex)

        const data = /*this.*/ arrayToArrayBuffer(prefixBytes)

        console.log('before encrypt')
        return window.crypto.subtle
            .encrypt(
                { name: 'RSA-OAEP' },
                COMTRUEVAR.requestEncryptPublicKeyComtrue,
                data
            )
            .then((result) => {
                const encArray = new Uint8Array(result)
                return new Uint8Array([...encArray, ...suffixBytes])
            })
            .catch((err) => {
                console.error(err)
                throw new Error(err)
                // setTimeout(() => {
                //     capture(cardType);
                // }, 1500);
            })
        console.log('after encrypt') // 이 로그가 안 찍히면 암호화가 멈춘 것
    }

    const encryptTextWithPublicKey = (text) => {
        console.log(
            'function COMTRUEEncryptUtils.encryptTextWithPublicKey start!'
        )
        const data = /*this.*/ arrayToArrayBuffer(text)
        return window.crypto.subtle
            .encrypt(
                { name: 'RSA-OAEP' },
                COMTRUEVAR.requestEncryptPublicKeyComtrue,
                data
            )
            .then((result) => {
                const encText = /*this.*/ arrayBufferToString(result)
                return window.btoa(encText)
            })
    }

    const encryptSplitTextWithPublicKey = (uint8Array) => {
        console.log(
            'function COMTRUEEncryptUtils.encryptSplitTextWithPublicKey start!'
        )
        const divideIndex = 190
        const prefixBytes = uint8Array.subarray(0, divideIndex)
        const suffixBytes = uint8Array.subarray(divideIndex)

        const data = /*this.*/ arrayToArrayBuffer(prefixBytes)

        return window.crypto.subtle
            .encrypt(
                { name: 'RSA-OAEP' },
                COMTRUEVAR.requestEncryptPublicKeyComtrue,
                data
            )
            .then((result) => {
                const encArray = new Uint8Array(result)
                const concatArray = [...encArray, ...suffixBytes]
                const encText = /*this.*/ arrayBufferToString(concatArray)
                return window.btoa(encText)
            })
    }

    const decryptTextWithPrivateKey = (data) => {
        console.log('function decryptTextWithPrivateKey start!')
        const buffer = /*this.*/ arrayToArrayBuffer(data)
        return window.crypto.subtle.decrypt(
            { name: 'RSA-OAEP' },
            COMTRUEVAR.responseDecryptPrivateKeyComtrue,
            buffer
        )
    }

    const decryptWithPrivateKey = (data) => {
        console.log('function decryptWithPrivateKey start!')
        const uint8Array = new Uint8Array(data)
        const divideIndex = 256
        const prefixBytes = uint8Array.subarray(0, divideIndex)
        const suffixBytes = uint8Array.subarray(divideIndex)

        const data2 = /*this.*/ arrayToArrayBuffer(prefixBytes)

        return window.crypto.subtle
            .decrypt(
                { name: 'RSA-OAEP' },
                COMTRUEVAR.responseDecryptPrivateKeyComtrue,
                data2
            )
            .then((result) => {
                const encArray = new Uint8Array(result)
                return new Uint8Array([...encArray, ...suffixBytes])
            })
    }

    const importPublicKey = (pem) => {
        console.log('importPublicKey start !!!')
        const binaryDerString = window.atob(pem)
        const binaryDer = /*this.*/ stringToArrayBuffer(binaryDerString)
        return window.crypto.subtle
            .importKey(
                'spki',
                binaryDer,
                {
                    name: 'RSA-OAEP',
                    hash: { name: 'SHA-256' },
                },
                false,
                ['encrypt']
            )
            .catch((err) => {
                console.error('Public Key Import Error:', err)
                sendPostMessageClose()
                closeThis(
                    '키 세팅에 오류가 발생했습니다.\n캐시를 삭제한 뒤 처음부터 다시 진행해주세요.'
                )
            })
    }

    const importPrivateKey = (pem) => {
        const binaryDerString = window.atob(pem)
        const binaryDer = /*this.*/ stringToArrayBuffer(binaryDerString)
        return window.crypto.subtle
            .importKey(
                'pkcs8',
                binaryDer,
                {
                    name: 'RSA-OAEP',
                    hash: { name: 'SHA-256' },
                },
                false,
                ['decrypt']
            )
            .catch((err) => {
                console.error('Private Key Import Error:', err)
                sendPostMessageClose()
                closeThis(
                    '키 세팅에 오류가 발생했습니다.\n캐시를 삭제한 뒤 처음부터 다시 진행해주세요.'
                )
            })
    }

    const stringToUint8Array = (text) => {
        const array = []
        for (let i = 0; i < text.length; i++) {
            array.push(text.charCodeAt(i))
        }
        return new Uint8Array(array)
    }

    const encryptStringToArray = (text) => {
        const blobBin = atob(text)
        const array = []
        for (let i = 0; i < blobBin.length; i++) {
            array.push(blobBin.charCodeAt(i))
        }
        return array
    }
    return {
        importRsaKeys,
        arrayToArrayBuffer,
        stringToArrayBuffer,
        arrayBufferToString,
        stringToArray,
        encryptDataWithPublicKey,
        encryptTextWithPublicKey,
        encryptSplitTextWithPublicKey,
        decryptTextWithPrivateKey,
        decryptWithPrivateKey,
        importPublicKey,
        importPrivateKey,
        stringToUint8Array,
        encryptStringToArray,
    }
}

export default createCOMTRUEEncryptUtils
